import React from 'react';
import PropTypes from 'prop-types';
import LandingPageFullWidthUploadPanelCTA from 'LandingPageFullWidthUploadPanelCTA';
import LandingPagePhotoToPDFModal from 'LandingPagePhotoToPDFModal';

class JPGToPDFLandingPageFullWidthUploadPanel extends React.PureComponent {
  render() {
    return (
      <div className="large-upload-panel-upload-section-wrapper">
        <div className="upload-wrap edit-pages-upload-wrap hide-for-photos">
          <form className="uploader">
            <div className="alert alert-error uploader-error">Error</div>
            <div className="uploader-area edit-pages-uploader-area">
              <img
                src="/images/icon-jpg-to-pdf.png"
                alt="JPG to PDF Icon"
                className="large-upload-panel-jpg-to-pdf-icon"
              />
              <h3 className="large-upload-panel-header">Convert Your Images to a PDF</h3>
              <p className="large-upload-panel-sub-header">
                {this.props.subHeader}
              </p>
              <LandingPageFullWidthUploadPanelCTA
                ctaId={this.props.ctaId}
                ctaText={'Upload an Image to Convert'}
                ctaOnClick={() => {}}
              />
            </div>
          </form>
        </div>
        <LandingPagePhotoToPDFModal />
      </div>
    );
  }
}

JPGToPDFLandingPageFullWidthUploadPanel.defaultProps = {
  subHeader: 'JPG or PDF',
};

JPGToPDFLandingPageFullWidthUploadPanel.propTypes = {
  ctaId: PropTypes.string.isRequired,
  subHeader: PropTypes.string,
};

export default JPGToPDFLandingPageFullWidthUploadPanel;



// WEBPACK FOOTER //
// ./src-react/JPGToPDFLandingPage/JPGToPDFLandingPageFullWidthUploadPanel.jsx